import React from 'react';
import { connect } from "react-redux";
import Topmenu from "../components/topmenu";
import { BoardContainerProps } from "../types/board.types";
import BoardConst from '../utils/constants/board';

type Props = {
  board: BoardContainerProps;
};

function BoardContainer({ board }: Props) {
  const { boardDetails, boardView = '' } = board;

  const hideVisualBoardHeader = !((boardView == BoardConst.BOARD_VIEW_SHARED) && Object.keys(boardDetails.board).length > 0);

  return hideVisualBoardHeader ? <Topmenu /> : <></>;
}

export default connect((state: BoardContainerProps) => ({ board: state }))(BoardContainer);
